import React from "react";
import EmailInput from "../../../../../../components/inputs/email/emailInput";
import { CoachListContext } from "../../../context/coachListContext";
import CoachProps from "../../../interface/coachProps";
import EditCoachProps from "../../../interface/editCoachProps";

const RenderEmailInput = (): React.JSX.Element => {
  const {
    setEditCoach,
    editCoach,
  }: {
    setEditCoach: (editCoach: {
      showDialog: boolean;
      coach: CoachProps;
    }) => void;
    editCoach: EditCoachProps;
  } = React.useContext(CoachListContext);
  return (
    <EmailInput
      disabled={false}
      required={true}
      email={editCoach.coach.email}
      setEmail={(email: string) =>
        setEditCoach({
          ...editCoach,
          coach: {
            ...editCoach.coach,
            email: email,
          },
        })
      }
    />
  );
};

export default RenderEmailInput;
